import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_BLACK } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const Track5FBlack = ({ state, workState, onLabelClick }) => (
	<g id="Track5FBlack" transform="translate(1468.000000, 561.000000)" className="track">
		<g id="line"
			 className="track"
			 transform="translate(0.153001, 0.000000)"
			 stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLACK)} strokeLinecap="round"
			 strokeWidth={tracksWidth}
		>
			<line x1="162.736831" y1="56.6697439" x2="-4.26325641e-14" y2="281" strokeWidth={tracksWidth}/>
			<TrackArrow
				points="174.797053 53.6691203 166.797053 45.6691203 174.797053 37.6691203"
				transform="translate(170.797053, 45.669120) rotate(-57.000000) translate(-170.797053, -45.669120) "
			/>

			<line x1="203.846999" y1="1.00541797e-12" x2="169.627194" y2="47.1714825" strokeWidth={tracksWidth}/>
		</g>

		<Label
			coords={'79.748977, 126.457582'}
			onClick={(event, ref) => onLabelClick(event, ref, 'Track5FBlack')}
			text='5F'
			textCoordsX={'10.7822266'}
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLACK)}
		/>
	</g>
);

Track5FBlack.propTypes = trackPropTypes;

export default Track5FBlack;
